module.exports = __webpack_public_path__ + "img/xmsb5.aa2b0d63.png";